import React from "react";
import {
  Siren,
  Droplets,
  Search,
  Flame,
  Wrench,
  Toilet,
  ShowerHead,
  Pipette,
  Building2,
  Home,
  Award,
  ShieldCheck,
  MapPin,
} from "lucide-react";

const MAP = {
  Siren,
  Droplets,
  Search,
  Flame,
  Wrench,
  Toilet,
  ShowerHead,
  PipetteIcon: Pipette,
  Building2,
  Home,
  Award,
  ShieldCheck,
  MapPin,
};

export default function ServiceIcon({ name, className = "h-7 w-7", strokeWidth = 1.5 }) {
  const Icon = MAP[name] || Wrench;
  return <Icon className={className} strokeWidth={strokeWidth} />;
}
